/*  eslint-disable */
import doBookExperience from '../api/CallMeLater';
import SafeConsole from '../util/ConsoleUtils';

// https://enterprise-bitbucket.asurion.com/projects/AW/repos/att-onboarding/pull-requests/52/diff#src/onboarding/schedule/actions/scheduleAction.js
// https://stackoverflow.com/questions/46241827/fetch-api-requesting-multiple-get-requests

export const bookExperience = (bookingPayload) => {
  SafeConsole.log('bookExperience bookingPayload = ', bookingPayload);
  return (dispatch) => {
    return doBookExperience(bookingPayload)
      .then((response) => {
        SafeConsole.log('bookExperience success reponse: ', response);
        // dispatch(setExperienceBookingSuccess(bookingPayload.appointmentData));
        return bookingPayload;
      })
      .catch((error) => {
        SafeConsole.log('bookExperience error reponse: ', error);
        // dispatch(setExperienceBookingSuccess(bookingPayload.appointmentData));
        throw bookingPayload;
      });
  };
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/actions/callMeLater.js